import { BackendApi } from '../shared';
import {
  CHMedicationDto,
  CHAllergyDto,
  CHConditionDto,
  CHProcedureDto,
  CHReportsListDto,
  CHReportsSummaryDto,
  CHPatientMappingDto
} from '../../core/types/ConsolidateHealth';

class ConsolidateHealthService {
  private readonly apiPath = '/consolidate-health';

  async getMedications(): Promise<CHMedicationDto[]> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/medications`);
      return response.data;
    } catch (error) {
      console.error('Error fetching medications:', error);
      throw error;
    }
  }

  async getAllergies(): Promise<CHAllergyDto[]> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/allergies`);
      return response.data;
    } catch (error) {
      console.error('Error fetching allergies:', error);
      throw error;
    }
  }

  async getConditions(): Promise<CHConditionDto[]> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/conditions`);
      return response.data;
    } catch (error) {
      console.error('Error fetching conditions:', error);
      throw error;
    }
  }

  async getProcedures(): Promise<CHProcedureDto[]> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/procedures`);
      return response.data;
    } catch (error) {
      console.error('Error fetching procedures:', error);
      throw error;
    }
  }

  async getAllReports(): Promise<CHReportsListDto> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/all`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all reports:', error);
      throw error;
    }
  }

  async getReportsSummary(): Promise<CHReportsSummaryDto> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/summary`);
      return response.data;
    } catch (error) {
      console.error('Error fetching reports summary:', error);
      throw error;
    }
  }

  // Pro user methods (for future use)
  async getMedicationsByUserId(userId: string): Promise<CHMedicationDto[]> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/medications/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching medications for user:', error);
      throw error;
    }
  }

  async getAllergiesByUserId(userId: string): Promise<CHAllergyDto[]> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/allergies/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching allergies for user:', error);
      throw error;
    }
  }

  async getConditionsByUserId(userId: string): Promise<CHConditionDto[]> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/conditions/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching conditions for user:', error);
      throw error;
    }
  }

  async getProceduresByUserId(userId: string): Promise<CHProcedureDto[]> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/procedures/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching procedures for user:', error);
      throw error;
    }
  }

  async getAllReportsByUserId(userId: string): Promise<CHReportsListDto> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/all/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all reports for user:', error);
      throw error;
    }
  }

  async getReportsSummaryByUserId(userId: string): Promise<CHReportsSummaryDto> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/summary/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching reports summary for user:', error);
      throw error;
    }
  }

  async getPatientMapping(): Promise<CHPatientMappingDto> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/patient-mapping`);
      return response.data;
    } catch (error) {
      console.error('Error fetching patient mapping summary for user:', error);
      throw error;
    }
  }

  async syncPatientReports(): Promise<CHPatientMappingDto> {
    try {
      const response = await BackendApi.get(`${this.apiPath}/sync-patient-reports`);
      return response.data;
    } catch (error) {
      console.error('Error sync patient reports for user:', error);
      throw error;
    }
  }
}

export default new ConsolidateHealthService();
